import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { OrganizationPriceInput } from 'organization/model/organization-price.input';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserReferenceInput } from '../model/user-reference.input';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface UpdateCoachProfileInput {
	readonly birthDate: string;
	readonly firstName: string;
	readonly id: string;
	readonly lastName: string;
	readonly phoneNumber: string;
	readonly planPrice: OrganizationPriceInput;
	readonly references: UserReferenceInput[];
	readonly sectors: string;
	readonly sessionPrice: OrganizationPriceInput;
	readonly shortDescription: string;
	readonly timeZone: string;
	readonly currentAddress: string;
	readonly birthAddress: string;
	readonly linkedInUrl: string;
}

export interface UpdateCoachProfileParams {
	input: UpdateCoachProfileInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateCoachProfileApiMutation extends ApiMutation<
	UserOutput,
	UpdateCoachProfileParams
> {
	client = 'iam';
	document = gql`
		mutation UpdateCoachProfile($input: UpdateCoachProfileInput!) {
			updateCoachProfile(input: $input) {
				...User
			}
		}
		${user}
	`;
	method = 'updateCoachProfile';
}
